<template>
  <div class='container'>
    <RecycleScroller
      class='nodes'
      :items='visiblePaths'
      :item-size='24'
      key-field='path'
      v-slot='{ item }'
      >
      <div :style='{
        "padding-left": (item.path.split("/").length * 16 - 48)+ "px",
        "padding-top": "4px"
      }'>
        <router-link v-if='item' :to='`/${item.path}`'>{{ item.name }}</router-link>
      </div>
    </RecycleScroller>
    <div class='content'>
      <ContentNode :path='`${this.region}/${this.version}/${this.nodePath}`' />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ContentNode from '@/components/ContentNode'

export default {
  name: 'NodeView',
  created() { this.FetchData() },
  watch: { '$route': 'FetchData' },
  components: { ContentNode },

  methods: {
    ...mapActions(['GetPath']),
    FetchData() {
      let pathPromises = this.nodePath.split('/').reduce((parent, current) => {
        if (!current) return parent

        let totalPath = parent.totalPath + '/' + current
        console.log('Git', totalPath)
        let pathPromise = this.GetPath(totalPath)
        let result = { totalPath, pathPromise, parent }
        return result
      }, {
        totalPath: `${this.region}/${this.version}`,
        pathPromise: this.GetPath(`${this.region}/${this.version}`)
      })
    },
  },
  computed: {
    nodePath() { return this.$route.params.pathMatch || '' },
    region() { return this.$route.params.region },
    version() { return this.$route.params.version },
    visiblePaths() {
      let pathKeys = Object.keys(this.$store.state.paths)
      let currentPath = `${this.region}/${this.version}/${this.nodePath}`
      let filtered = pathKeys.filter((path, index) => {
        let lastIndex = path.lastIndexOf('/')
        return currentPath.startsWith(path.substr(0, lastIndex))
      })

      filtered.sort()
      filtered.shift()

      return filtered.map((path, __index) => ({
        __index,
        ...this.$store.state.paths[path],
      }))
    }
  }
}
</script>

<style scoped lang='less'>
  .container {
    display: flex;
    height: 100%;

    .nodes {
      height: 100%;
      overflow: auto;
      flex-grow: 1;

      a { padding: 2px; margin: 2px; display:block; border-left: 1px solid #3690ff; }
    }
  }
</style>